import React, { useEffect } from 'react';
import { Skeleton } from 'antd';
import NetworkWidget from 'components/widgets/components/NetworkWidget';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import ninjaApi from 'store/redux/apis';
import { useWidget } from 'components/Widget/useWidget';

const defaultData = {
  gross_income: 0,
  gross_profit: 0,
  net_profit: 0,
  ad_spent: 0,
};

const TotalPnL = ({ data, index, height }) => {
  const { filters } = useWidget();
  const [getDashboardTotals, { data: response = [], isLoading, isFetching }] =
    ninjaApi.useLazyDashboardTotalsQuery();
  const { date_from, date_to, date_range_key } = useWidgetDate('totalPnL_widget' + index);

  useEffect(() => {
    const params = {
      ...data.defaultFilter,
      date_from: date_from,
      date_to: date_to,
      date_range_key: date_range_key,
      ...filters,
    };

    if (params?.date_from) {
      getDashboardTotals(params).unwrap();
    }
  }, [filters]);

  const dataList = response?.data || defaultData;

  return (
    <Skeleton loading={isLoading || isFetching} active={true}>
      <NetworkWidget data={dataList} height={height - 60} />
    </Skeleton>
  );
};

export default TotalPnL;
